import { render, staticRenderFns } from "./IEDatePicker.vue?vue&type=template&id=edd0255e"
import script from "./IEDatePicker.vue?vue&type=script&lang=ts"
export * from "./IEDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports